import {useGetSession, useGetUser, useGetUserActivities} from '@/modules/users/api'
import {EventLog, Session, User} from '@cypro/engine/schema'
import {createContext, PropsWithChildren, useContext} from 'react'

interface State {
  user: User
  session: Session | undefined
  activities: EventLog[] | undefined
}

interface Props extends PropsWithChildren {
  user: User
}

const UserContext = createContext<State>({} as State)

export function UserProvider({children, user: initialUser}: Props) {
  const [user] = useGetUser(initialUser?.id)
  const [session] = useGetSession(initialUser?.id)
  const [activities] = useGetUserActivities(initialUser?.id)

  return (
    <UserContext.Provider value={{user: user || initialUser, session, activities}}>{children}</UserContext.Provider>
  )
}

export function useUserContext() {
  return useContext(UserContext)
}
